var ___EXPOSE_LOADER_IMPORT___ = require("-!../node_modules/ts-loader/index.js!./app.ts");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["App"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["App"] = ___EXPOSE_LOADER_IMPORT___;
else throw new Error('[exposes-loader] The "App" value exists in the global scope, it may not be safe to overwrite it, use the "override" option')
module.exports = ___EXPOSE_LOADER_IMPORT___;
